import { EventAvailable, LocationOn } from '@mui/icons-material';
import { MatchesLoading as DefaultMatchesLoading, MatchesLoadingProps } from '../../default/steps';
import { Card, VolunteerActivismIcon } from '@uplift/icons';

export const MatchesLoading: React.VFC<MatchesLoadingProps> = props => {
  return (
    <DefaultMatchesLoading
      {...props}
      title="Gathering the best providers"
      steps={[
        {
          title: 'Near you',
          icon: LocationOn,
        },
        {
          title: 'Accept your insurance',
          icon: Card,
          hidden: !props.hasInsurance
        },
        {
          title: 'Have upcoming availability',
          icon: EventAvailable,
        },
        {
          title: 'Match your needs',
          icon: VolunteerActivismIcon,
        }
      ]}
    />
  );
};
